import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PlanSelector } from "@/components/PlanSelector";
import { Zap } from "lucide-react";

export function PaywallModal({ open, onClose, reason }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md sm:max-w-lg rounded-3xl max-h-[90vh] overflow-y-auto" data-testid="paywall-modal">
        <DialogHeader className="text-left space-y-2">
          <div className="w-12 h-12 rounded-2xl bg-whoo-soft text-whoo flex items-center justify-center">
            <Zap className="w-6 h-6" />
          </div>
          <DialogTitle className="font-heading text-2xl">Passa a WhooNow Pro</DialogTitle>
          <DialogDescription className="text-sm text-slate-600 leading-relaxed">
            <span className="font-semibold text-slate-900">Più opportunità. Zero commissioni sui tuoi lavori.</span>
            {reason ? ` ${reason}` : ""}
          </DialogDescription>
        </DialogHeader>
        <div className="bg-whoo-soft rounded-2xl p-3.5 text-xs text-slate-700 leading-relaxed" data-testid="paywall-zero-fees-note">
          WhooNow non trattiene percentuali sui tuoi interventi. Con Pro accedi alle opportunità professionali della piattaforma e ciò che guadagni dal tuo lavoro rimane a te.
        </div>
        <PlanSelector />
      </DialogContent>
    </Dialog>
  );
}
